import { Card } from '@yleisradio/areena-types';
import React, { useEffect, useRef, useState } from 'react';
import logger from 'services/logger';
import { trackCardView } from 'services/snowplowAnalytics/snowplowAnalytics';
import { findLabel } from 'utils/card';
import { GroupEngagementData } from './types';

type Props = {
  card: Card;
  cardIndex: number;
  children?: React.ReactNode;
  groupData: GroupEngagementData;
  viewUuid: string;
};

export const ViewableCard: React.FC<Props> = ({
  card,
  cardIndex,
  children,
  groupData,
  viewUuid,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isSent, setSent] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node || isSent) return;

    const observer = new IntersectionObserver(([entry]) => {
      if (!entry || !entry.isIntersecting) return;

      const entityId = getEntityIdForCard(card);

      if (!entityId) {
        logger.error('No entityId found for card', card);
        return;
      }

      trackCardView({
        cardIndex,
        cardTitle: card.title,
        cardViewUuid: viewUuid,
        entityId,
        imageId: card.image?.id,
        isListPaginated: groupData.isPaginated,
        listIndex: groupData.index,
        listLabel: groupData.label,
        listStyle: groupData.style,
        listLength: groupData.length,
        listReferer: groupData.referer,
        listUrl: groupData.url,
      });
      setSent(true);
    });

    observer.observe(node);

    return () => {
      observer.disconnect();
    };
  }, [card, cardIndex, groupData, isSent, viewUuid]);

  return <div ref={ref}>{children}</div>;
};

function getEntityIdForCard(card: Card): string | undefined {
  return findLabel(card.labels, 'itemId')?.raw;
}
